import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePlatformPageMutation } from "../graphql/mutations";

export const useUpdatePlatformPageMutation = (
  options?: MutationHookOptions<any, any>
) => {
  return useMutation<any, any>(UpdatePlatformPageMutation, options);
};
